<div class="cadastro-tabela-preco-fin-container">
  <div class="header">
    <div>
      <h1>{{ id > 0 ? 'Editar Tabela de Preços' : 'Cadastrar Tabela de Preços' }}</h1>
      <p class="subtitle">Configure valores e vigência da tabela financeira.</p>
    </div>
  </div>

  <div class="card-box">
    <div class="row g-3">
      <div class="col-12 section-title">Dados principais</div>
      <div class="col-12">
        <label class="form-label">Descrição *</label>
        <input type="text" class="form-control" [(ngModel)]="descricao" placeholder="Descrição do serviço" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Documento *</label>
        <app-select-busca [opcoes]="documentos" [(ngModel)]="idFinDocumento"></app-select-busca>
      </div>
      <div class="col-md-4">
        <label class="form-label">Fornecedor *</label>
        <app-select-busca [opcoes]="fornecedores" [(ngModel)]="idFinFornecedor"></app-select-busca>
      </div>
      <div class="col-md-4">
        <label class="form-label">Microserviços *</label>
        <app-select-busca [opcoes]="microservicos" [(ngModel)]="idMicroservicos"></app-select-busca>
      </div>
      <div class="col-md-6">
        <label class="form-label">Plano de Contas *</label>
        <app-select-busca [opcoes]="planosContas" [(ngModel)]="planoContasId"></app-select-busca>
      </div>

      <div class="col-12 section-title mt-2">Valores</div>
      <div class="col-md-4">
        <label class="form-label">Valor</label>
        <div class="input-group">
          <span class="input-group-text">R$</span>
          <input type="number" step="0.01" class="form-control" [(ngModel)]="valor" placeholder="0,00" />
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Valor Dollar</label>
        <div class="input-group">
          <span class="input-group-text">$</span>
          <input type="number" step="0.01" class="form-control" [(ngModel)]="valorDollar" placeholder="0,00" />
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Valor Euro</label>
        <div class="input-group">
          <span class="input-group-text">€</span>
          <input type="number" step="0.01" class="form-control" [(ngModel)]="valorEuro" placeholder="0,00" />
        </div>
      </div>

      <div class="col-12 section-title mt-2">Vigência</div>
      <div class="col-md-4">
        <label class="form-label">Início Vigência *</label>
        <input type="date" class="form-control" [(ngModel)]="inicioVigencia" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Fim Vigência</label>
        <input type="date" class="form-control" [(ngModel)]="fimVigencia" />
      </div>
    </div>

    <div class="acoes mt-3">
      <button type="button" class="btn btn-outline-secondary" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
      <button type="button" class="btn btn-success" (click)="salvar()">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </div>
</div>
